const getEventIdxFromUrl = () => {
	const currentUrl = window.location.href
	const eventIdxMatch = currentUrl.match(/eventIdx=(\d+)/)
	const eventIdx = eventIdxMatch ? parseInt(eventIdxMatch[1]) : null

	const url = new URL(window.location.href)
	const eventIdxFromUrl = url.searchParams.get('eventIdx')

	if (eventIdx !== null) return eventIdx
	return Number(eventIdxFromUrl)
}

export default getEventIdxFromUrl
